import { getRequestWithQuery } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";

const api = getApiWithVersion(API_VERSION.V1)

export interface UtmQuery{
    getUtmQuery(utmQuery:any):Promise<any>
}

const utmQuery:UtmQuery={
    getUtmQuery(utmQuery){
      
        const q = {query:utmQuery}
        return getRequestWithQuery(api.UTM_QUERY,q)
    }
}

export default utmQuery